"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Career_Location = void 0;
var Career_Location;
(function (Career_Location) {
    Career_Location["UAE"] = "uae";
    Career_Location["KSA"] = "ksa";
})(Career_Location = exports.Career_Location || (exports.Career_Location = {}));
//# sourceMappingURL=career.js.map